<template>
  <div
    class="header"
    v-click-outside="
      () => {
        showDropdown = false;
      }
    "
  >
    <div class="logo" @click="redirectToIntro()">
      <img src="@/assets/images/Main_Black.svg" alt />
    </div>
    <span class="dev"></span>
    <div class="search-panel" ref="planInfo">
      <div class="search-container" v-if="showInput">
        <i
          :class="[searchInput ? 'bi bi-x-lg rd-btn' : 'bi bi-search']"
          @click="searchInput && (searchInput = '')"
        ></i>
        <input
          type="text"
          v-model="searchInput"
          class="search-panel"
          :placeholder="$t('HEADER_SEARCH')"
          size="auto"
        />
      </div>
      
    </div>
    <div class="profile-panel">
      <div class="drpdown">
        <input type="checkbox" name id="z1" v-model="showDropdown" />
        <label for="z1" class="profiles-list">{{ getProfile.email }}</label>
        <span class="expand"></span>
        <ul class="drp-profile">
          <div class="plan-info">
            <div class="active-plan">
              {{ $t('PRC_PLN') }}: <span>{{ getProfile.plan }}</span>
            </div>

            <span class="plan-details">{{ $t('PRC_USED') }}: {{ getProfile.pageCount }}/{{ getProfile.page_limit }}</span>
            <span class="plan-details">{{ $t('PRC_ADMIN_USED') }}: {{ getProfile.adminUserCount }}/{{ getProfile.admin_limit }}</span>
            <span class="exp-plan">{{ $t('PRC_EXPR') }}: {{ getProfile.expire }}</span>
            <a class="btn-st-red" href="plans" target="_self">{{ $t('PRC_UPGR') }}</a>
          </div>
          <!--<div class="plan-info">
            <div class="active-plan">
              {{ $t('PRC_PLN') }}: <span>Free</span>
            </div>
            <span class="plan-details">{{ $t('PRC_USED') }}: 2/2</span>
            <a class="btn-st-red" href="/plans" target="_self">{{ $t('PRC_UPGR') }}</a>
          </div>-->
          <li
            @click.stop="
              INTRO_SET_SETTINGS_MODAL_VISIBLE(true);
              showDropdown = false;
            "
          >
            {{ $t('PROFILE_SETTINGS') }}
          </li>
          <!-- <li
            @click.stop="
              $router.push({ path: '/reports' });
              showDropdown = false;
            "
          >
            {{ $t('HEADER_REPORTS_MANAGE') }}
          </li> -->
          <li @click.stop="AUTH_LOGOUT">{{ $t('HEADER_LOG_OUT') }}</li>
          <div class="drp-options">
            <label for="io8" class="lang-set">
              <input type="checkbox" name="io8" id="io8">
              <i class="bi bi-globe"></i>
              <ul class="lang-list">
                <li @click="changeLanguage('en')">English</li>
                <li @click="changeLanguage('de')">Deutsch</li>
                <li @click="changeLanguage('es')">Español</li>
                <li @click="changeLanguage('pt')">Português</li>
                <li @click="changeLanguage('ru')">Русский</li>
              </ul>
            </label>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import {
  INTRO_SET_ACCESS_MANAGER_VISIBLE,
  INTRO_SET_SETTINGS_MODAL_VISIBLE,
  INTRO_SET_SEARCH_INPUT,
  INTRO_SET_PAGES,
} from "../store/actions/intro";
import {
  AUTH_GET_PROFILE,
  AUTH_GET_ALERTS,
} from "../store/actions/auth";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import ClickOutside from "vue-click-outside";

import Alert from '@/components/Alert.vue';
import module from '@/models/AxiosModule'

export default {
  name: "Header",
  components: {
    Alert
  },
  props: {
    showInput: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["getProfile", "getSearchInputText"]),
    locale() {
    },
    searchInput: {
      get() {
        return this.getSearchInputText;
      },
      set(value) {
        this.INTRO_SET_SEARCH_INPUT(value);
      },
    },
  },
  data() {
    return {
      showDropdown: false,
      planAlertInstance: null,
    };
  },
  watch: {
    getProfile(newVal) {
      if (newVal && newVal.plan === 'Basic') {
        this.showPlanAlert();
      } else {
        this.clearPlanAlert();
      }
    },
  },
  mounted() {
    this.popupItem = this.$el;
    this.AUTH_GET_PROFILE()
    this.AUTH_GET_ALERTS()
  },
  methods: {
    ...mapMutations([INTRO_SET_ACCESS_MANAGER_VISIBLE, INTRO_SET_SEARCH_INPUT, INTRO_SET_SETTINGS_MODAL_VISIBLE]),
    ...mapActions([AUTH_LOGOUT, INTRO_SET_PAGES, AUTH_GET_PROFILE, AUTH_GET_ALERTS]),
    async changeLanguage(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('userLanguage', lang);
      try {
        const axios = module.Axios;
        const response = await axios.post("set-locale", {
          email: this.getProfile.email,
          locale: lang
        });
        console.log("Locale set successfully:", response.data);
      } catch (error) {
        console.error("Error setting locale:", error);
      }      
    },
    redirectToIntro() {
      if (this.$route.path == "/main") this.INTRO_SET_PAGES();
      else this.$router.push({ path: "/main" });
    },
    showPlanAlert() {
      if (!this.planAlertInstance) {
        this.planAlertInstance = this.$alert.show({
          message: this.$i18n.t('ALERT_BASIC_PLAN'),
          type: 'inline',
          color: 'basic-plan',
          component: this,
          duration: 0,
          target: this.$refs.planInfo,
        });
      }
    },
    clearPlanAlert() {
      if (this.planAlertInstance) {
        this.planAlertInstance.close();
        this.planAlertInstance = null;
      }
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>

<style></style>